export default __webpack_public_path__ + "static/box-d5340bd2d9bb163ee3098018cf8b9a16.png";